import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheJavaExperience from "./sections/TheJavaExperience";
import PartnershipValueProposition from "./sections/PartnershipValueProposition";
import VisualStorytellingExpertise from "./sections/VisualStorytellingExpertise";
import ProtectionByTheNumbers from "./sections/ProtectionByTheNumbers";
import PremiumCourseCta from "./sections/PremiumCourseCta";
import PortfolioComingSoon from "./sections/PortfolioComingSoon";
import StartYourBuild from "./sections/StartYourBuild";
import MarketplaceFooter from "@/reusable_sections/Footer";
import CourseTypeShowcase from "./sections/CourseTypeShowcase";
import BeneficiosDeInstalarAerotermiaEnMirandaDeEbro from "./sections/BeneficiosDeInstalarAerotermiaEnMirandaDeEbro";
export default function HomePage() {
  return <div>
      <Header />
      <TheJavaExperience />
      <PartnershipValueProposition />
      <CourseTypeShowcase />
      <BeneficiosDeInstalarAerotermiaEnMirandaDeEbro />
      <VisualStorytellingExpertise />
      <ProtectionByTheNumbers />
      <PremiumCourseCta />
      <PortfolioComingSoon />
      <StartYourBuild />
      <MarketplaceFooter />
    </div>;
}